// React
import React from 'react';

// MUI
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';

// aligns the summary with sibling section headers at the left edge
// (used by the Devices/Controllers tabs; flow panels keep the default padding)
export const techDetailsSx = {
    '& .MuiAccordionSummary-root': {paddingLeft: 0, paddingRight: 0},
    '& .MuiAccordionSummary-content': {marginY: 0.5},
};

export default function AdvancedSection(props) {
    return (
        <Accordion elevation={0} sx={{mt: 1, borderTop: '1px solid', borderColor: 'divider', '&:before': {display: 'none'}, ...(props.sx || {})}}>
            <AccordionSummary expandIcon={<Box component="span" sx={{fontSize: '0.875rem', color: 'text.secondary'}}>&#9660;</Box>} sx={{minHeight: 32, paddingY: 0.5, '&.Mui-expanded': {minHeight: 32}}}>
                <Box component="span" sx={{fontSize: '0.875rem', color: 'text.secondary'}}>{props.title || "Advanced"}</Box>
            </AccordionSummary>
            <AccordionDetails sx={{flexDirection:'column', display:'flex'}}>
                {props.children}
            </AccordionDetails>
        </Accordion>
    )
};

export {AdvancedSection};
